// 初始化请求后台知道是通过button还是checkout模式
export const INIT = "/web/v1/paypal/init";
export const APPROVE = "/web/v1/third_pay/approve";
export const BUTTON_CREATE = "/web/v1/paypal/b_create";
export const CHECKOUT_CREATE = "/web/v1/paypal/c_create";
